let auth={
    clientId: process.env.REACT_APP_CLIENTID || '',
    authority: process.env.REACT_APP_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_REDIRECTURI || 'http://localhost:3000',
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUTREDIRECTURI || 'http://localhost:3000',
}
let apiId = process.env.REACT_APP_APPID || ''
export const msalConfig = {
    auth: auth,
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    loginHint: localStorage.getItem('mail'),
    forceRefresh: true
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const apiRequest = {
    scopes: [apiId + '/access_as_user'],
    forceRefresh: false
};